interface ApiErrorProps {
  resetApiError: () => void;
}

export const ApiError = ({ resetApiError }: ApiErrorProps) => {
  return (
    <div className="w-full py-6 px-4 flex justify-center items-center">
      Error
    </div>
  );
};
